var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "35.8,30.8 33.6,28 6.5,28 4.3,30.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.8,41.1 41.7,38.4 14.5,38.4 12.4,41.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.9,51.5 49.7,48.7 22.5,48.7 20.4,51.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.9,61.8 57.7,59 30.6,59 28.4,61.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.6,69.3 36.4,72.1 67.9,72.1 65.7,69.3  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7,27.9L65.8,63h3.8l23-30.3v36.3h-23l2.3,3h23.8V27.9H38.7z M67.7,60.5L44.8,30.9h45.4   L67.7,60.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.3bbac43de282b2b6e2736567497c7e58.svg";
export { ForwardRef as ReactComponent };